export default {
      id: "plus-action-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#plus-action-usage",
      toString: function () {
        return this.url;
      }
    }